import React from 'react';

export function DiamondIcon() {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.1665 5.49902H11.1665V6.16504H4.3335L4.18311 6.36523L2.34424 8.81738L2.09814 9.14648L2.37256 9.45215L8.79541 16.5879L9.1665 17L9.53857 16.5879L16.0845 9.31348L16.5796 9.75977L9.41455 17.7217C9.35142 17.7918 9.26107 17.832 9.1665 17.832C9.09577 17.832 9.02756 17.8094 8.97119 17.7686L8.91943 17.7217L1.41943 9.38867C1.31295 9.27033 1.3047 9.09315 1.3999 8.96582L3.8999 5.63184C3.96279 5.54798 4.06171 5.49913 4.1665 5.49902ZM15.9751 1.79883C16.3831 2.78377 17.1453 3.57425 18.1089 4.00293L18.5815 4.21289L18.0737 4.43945C17.1342 4.85736 16.3844 5.61944 15.9692 6.57227L15.8335 6.88379L15.6978 6.57227C15.2826 5.61944 14.5328 4.85736 13.5933 4.43945L13.0845 4.21289L13.5581 4.00293C14.5216 3.57425 15.284 2.78381 15.6919 1.79883L15.8335 1.45703L15.9751 1.79883Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}
